import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'hubtiger-button',
  templateUrl: './hubtiger-button.component.html',
  styleUrls: ['./hubtiger-button.component.scss']
})
export class HubtigerButtonComponent {
  @Input() text?: string;
  @Input() icon?: string;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() disabled: boolean = false;
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'md';
  @Input() style: 'primary' | 'secondary' | 'outline' | 'outline-secondary' = 'primary';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  
  @Output() click = new EventEmitter<Event>();

  onButtonClick(event: Event): void {
    if (!this.disabled) {
      this.click.emit(event);
    }
  }

  get buttonClasses(): string {
    const isIconOnly = this.icon && !this.text;
    return `hubtiger-button hubtiger-button--${this.style} hubtiger-button--${this.size} ${isIconOnly ? 'hubtiger-button--icon-only' : ''} ${this.disabled ? 'hubtiger-button--disabled' : ''}`;
  }

  get iconSize(): string {
    const iconSizes = {
      'sm': '15px',
      'md': '15px', 
      'lg': '20px',
      'xl': '20px',
      '2xl': '24px'
    };
    return iconSizes[this.size];
  }

  get iconColor(): string {
    if (this.disabled) {
      return this.style.includes('outline') ? '#d1d1d1' : '#ffffff';
    }
    
    switch (this.style) {
      case 'primary':
      case 'secondary':
        return '#ffffff';
      case 'outline':
        return 'var(--hubtiger-primary)';
      case 'outline-secondary':
        return 'var(--hubtiger-secondary)';
      default:
        return '#ffffff';
    }
  }
}